import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { Capacitor } from '@capacitor/core'
import { ImageLink } from '../../store/useInventory'
import { onBeforeMount, ref } from 'vue'
import TableAvatar from '../wrappers/TableAvatar.vue'
import { AllPartsModel } from '../../models/AllParts'
import { DownloadImageData } from '../../models/AllParts'

export default /*#__PURE__*/_defineComponent({
  __name: 'RenderPartImage',
  props: {
    imageData: {},
    imageType: { default: 'standard' }
  },
  setup(__props: any) {

const props = __props

onBeforeMount(async () => {
  //before we mount, check if on device. If the image is not
  //saved to the device, we will initiate a download.
  //While that download is occurring, we have render placeholder
  //First, cancel check if we're on browser
  if (!Capacitor.isNativePlatform()) {
    path.value = await getPath(props.imageData)
    return
  }
  onDevice.value = await checkOnDevice()
  if (onDevice.value === false) {
    void download()
  } else {
    path.value = await getPath(props.imageData)
  }
})

const isNative = Capacitor.isNativePlatform()
const onDevice = ref(false)
const checkOnDevice = async () => {
  return await AllPartsModel().imageOnDevice(props.imageData)
}
const isDownloading = ref(false)
const download = async () => {
  isDownloading.value = true
  await AllPartsModel()
    .downloadPartImage(
      {
        id: props.imageData.id,
        name: props.imageData.name,
        link: props.imageData.link,
      },
      true
    )
    .then(async () => {
      path.value = await getPath(props.imageData)
    })

  isDownloading.value = false
  onDevice.value = await checkOnDevice()
}
const getPath = async (data: DownloadImageData) => {
  if (Capacitor.isNativePlatform()) {
    return Capacitor.convertFileSrc(await AllPartsModel().getImagePath(data))
  } else {
    return data.link
  }
}
const path = ref()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.imageType == 'thumbnail')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ((_unref(isNative) && onDevice.value && path.value) || !_unref(isNative))
            ? (_openBlock(), _createBlock(TableAvatar, {
                key: 0,
                src: path.value
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ((_unref(isNative) && onDevice.value && path.value) || !_unref(isNative))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: path.value
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})